
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Tabbar from '@/components/follow/TabBar.vue';
import FloatAvatar from './FloatAvatar.vue';
import Research from './Research.vue';
import { SCROLL_TIMEOUT, AVATAR_URL, tabItems } from '@/config/config';
import { throttle, getHangqing, getReadCount } from '@/utils/tools';
import { getReport } from '@/apis/index';
import CommonLoad from '@/components/common/CommonLoad.vue';
import Swiper from 'swiper';
@Component({
  components: {
    FloatAvatar,
    Tabbar,
    Research,
    CommonLoad,
  },
})
export default class Test extends Vue {
  @Prop() private swiperIndex!: number;
  @Prop() private showRound!: boolean;
  @Prop() private chooseAvatar!: number;
  @Prop() private author!: string;
  @Prop() private id!: string;
  @Prop() private itemCard!: any;
  showEmpty = false;
  showLoad = false;
  swIndex = 0;
  followList = [];
  swiper = null;
  pages = 0;
  swipeIndex = 0;
  showError = false;
  tabItems = tabItems;
  AVATAR_URL = AVATAR_URL;
  //滚动加载分页停止请求
  stopReq = false;
  //小三角距离屏幕左边的距离
  triangleLeft = 0;
  //当前激活的头像、作者
  name = '';
  avatarList: any = [];
  mechanismList: any = [];
  industryList: any = [];
  //loading样式
  loadStyle = {
    marginTop: '4rem',
    marginLeft: '41%',
    width: '50%',
  };
  //error样式
  errorStyle = {
    marginTop: '2rem',
  };
  //空状态样式
  emptyStyle = {
    position: 'absolute',
    top: '3.92rem',
    left: '2.55rem',
    fontFamily: 'PingFangSC-Regular',
    fontSize: '0.32rem',
    color: 'rgba(0, 0, 0, 0.84)',
    textAlign: 'center',
    lineHeight: '0.4rem',
  };
  activeStyle = {
    fontFamily: 'PingFangSC-Medium',
    fontSize: '.32rem',
    color: 'rgba(0,0,0,0.84)',
    lineHeight: '.4rem',
    fontWeight: 500,
  };
  defaultStyle = {
    fontFamily: 'PingFangSC-Regular',
    fontSize: '.32rem',
    color: 'rgba(0,0,0,0.60)',
    lineHeight: '.4rem',
    fontWeight: 400,
  };
  reportList = [];
  reportList2 = [];
  reportList3 = [];
  total = 5;
  listIsLoading = false;
  listFinished = false;
  scrollTop = 0;
  clientHeight = 0;
  scrollHeight = 0;
  showNoMore = false;
  showLoading = false;
  lock = false;
  lastSeq = null;
  //是否深度
  ifDeep = null;
  str = '';
  @Watch('swipeIndex')
  onSwiperChange(val: number) {
    this.pages = 0;
    if (val === 0) {
      window.sessionStorage.getItem('authorList');
    } else if (val === 1) {
      window.sessionStorage.getItem('orgList');
    } else {
      window.sessionStorage.getItem('industryList');
    }
  }
  swiperSlide(i: any) {
    this.swiper.slideTo(i);
  }
  changeSwiper(swiperIndex: number, index: number) {
    if (swiperIndex === 0) {
      this.swiper.activeIndex = index;
    } else if (swiperIndex === 1) {
      this.swiper.activeIndex = this.avatarList.length + index;
    } else {
      this.swiper.activeIndex = this.avatarList.length + this.mechanismList.length + index;
    }
  }
  //获取行情
  getHangqing(res: any) {
    getHangqing(res);
  }
  chartChange() {
    this.stopReq = false;
  }
  dealResponse(res: any) {
    this.reportList = res.data.list;
    this.showError = false;
    if (res.data.list.length > 0) {
      this.lastSeq = res.data.list[res.data.list.length - 1].seq;
      this.getReadCount(res.data.list);
      this.getHangqing(res);
    }
  }
  getDeep(deep: number) {
    this.pages = 0;
    this.stopReq = false;
    this.reportList = [];
    this.ifDeep = deep;
    getReport({
      report_type: 'follow',
      follow_id: this.id,
      follow_type: this.swipeIndex,
      is_deep: deep,
    })
      .then(res => {
        this.dealResponse(res);
      })
      .catch(() => {
        this.showError = true;
      });
  }
  //拼接获取阅读量的参数
  getReadCount(LIST: Array<object>) {
    getReadCount(this, LIST);
  }
  changeStatus() {
    this.$emit('changeStatus', this.swipeIndex);
  }
  changeName(name: string, id: string) {
    this.showLoad = true;
    this.showEmpty = false;
    this.showError = false;
    this.name = name;
    this.pages = 0;
    this.reportList = [];
    //接口加锁
    const interval = setInterval(() => {
      if (!this.lock) {
        window.clearInterval(interval);
        this.lock = true;
        getReport({
          report_type: 'follow',
          follow_id: id,
          follow_type: this.swipeIndex,
          is_deep: null,
        })
          .then(res => {
            this.showError = false;
            this.showLoad = false;
            this.reportList = res.data.list;
            if (res.data.list.length === 0) {
              this.showEmpty = true;
            }
            this.lock = false;
            if (res.data.list.length > 0) {
              this.lastSeq = res.data.list[res.data.list.length - 1].seq;
              this.getReadCount(res.data.list);
              this.getHangqing(res);
            }
          })
          .catch(() => {
            this.lock = false;
            this.showLoad = false;
            this.showError = true;
          });
      }
    }, 300);
  }
  //todo:popup滚动加载
  handleListLoad() {
    setTimeout(() => {
      // 加载结束将listIsLoading设置为false，否则再次滑到底部将不再触发load
      this.listIsLoading = false;
      if (this.reportList.length >= this.total) {
        // 加载全部数据后将listFinished设置为true，将不再触发load
        this.listFinished = true;
      } else {
        this.mergeList();
      }
    }, SCROLL_TIMEOUT);
  }
  //滚动加载
  mergeList() {
    getReport({
      page: this.pages,
      report_type: 'follow',
      seq: this.lastSeq,
      follow_id: this.id,
      follow_type: this.swipeIndex,
      is_deep: this.ifDeep,
    })
      .then(res => {
        this.showError = false;
        this.reportList = [...this.reportList, ...res.data.list];
        if (res.data.list.length > 0) {
          this.lastSeq = res.data.list[res.data.list.length - 1].seq;
          this.showNoMore = false;
          this.getReadCount(res.data.list);
          this.getHangqing(res);
        } else {
          this.stopReq = true;
          this.showNoMore = true;
          this.showLoading = false;
        }
      })
      .catch(() => {
        this.showError = true;
      });
  }
  closePop() {
    this.$emit('closePop');
  }
  changeTriangle(value: number) {
    this.triangleLeft = value;
  }
  clickTab(item: any, value: number) {
    this.reportList = [];
    this.swipeIndex = value;
    const float = this.$refs.float as any;
    if (value === 0) {
      if (this.avatarList.length === 0) {
        this.showEmpty = true;
      } else {
        this.showEmpty = false;
        float.checkAvatar(
          this.followList[0].author,
          0,
          this.followList[0],
          this.followList[0].authorId,
          this.swipeIndex,
          'slide'
        );
      }
    } else if (value === 1) {
      if (this.mechanismList.length === 0) {
        this.showEmpty = true;
      } else {
        this.showEmpty = false;
        float.checkAvatar(
          this.followList[this.avatarList.length].orgName,
          0,
          this.followList[this.avatarList.length],
          this.followList[this.avatarList.length].orgId,
          this.swipeIndex,
          'slide'
        );
      }
    } else {
      if (this.industryList.length === 0) {
        this.showEmpty = true;
      } else {
        this.showEmpty = false;
        float.checkAvatar(
          this.followList[this.avatarList.length + this.mechanismList.length].industry,
          0,
          this.followList[this.avatarList.length + this.mechanismList.length],
          this.followList[this.avatarList.length + this.mechanismList.length].industryId,
          this.swipeIndex,
          'slide'
        );
      }
    }
  }
  getScrollHeight() {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
  }
  scrollLoading() {
    const popup = document.getElementsByClassName('hxm-popup')[0];
    this.scrollTop = popup.scrollTop;
    this.clientHeight = popup.clientHeight;
    this.scrollHeight = popup.scrollHeight;
    const SCROLL_BIAS = 10;
    if (this.scrollTop + this.clientHeight + SCROLL_BIAS >= this.scrollHeight) {
      if (!this.stopReq) {
        this.pages++;
        this.showLoading = true;
        this.mergeList();
      } else {
        this.showNoMore = true;
      }
    } else {
      this.showNoMore = false;
      this.showLoading = false;
    }
  }
  //确保外层tabbar和浮层的tabbar激活的tab一致
  @Watch('swiperIndex')
  onIndexChange() {
    this.swipeIndex = this.swiperIndex;
  }
  makeSlide() {
    for (let i: number = 0; i < this.followList.length; i++) {
      if (
        this.followList[i].author === this.author ||
        this.followList[i].orgName === this.author ||
        this.followList[i].industry === this.author
      ) {
        this.swiper.slideTo(i);
        this.swiper.activeIndex = i;
      }
    }
  }
  refresh() {
    getReport({
      report_type: 'follow',
      follow_id: this.id,
      follow_type: this.swipeIndex,
      is_deep: window.sessionStorage.getItem('deep'),
    })
      .then(res => {
        this.dealResponse(res);
      })
      .catch(() => {
        this.showError = true;
      });
  }
  initData() {
    this.showError = false;
    this.showLoad = true;
    const index = Number(window.sessionStorage.getItem('index'));
    this.swipeIndex = this.swiperIndex;
    this.avatarList = JSON.parse(window.sessionStorage.getItem('author'));
    this.followList = this.followList.concat(this.avatarList);
    this.mechanismList = JSON.parse(window.sessionStorage.getItem('org'));
    this.followList = this.followList.concat(this.mechanismList);
    this.industryList = JSON.parse(window.sessionStorage.getItem('industry'));
    this.followList = this.followList.concat(this.industryList);
    this.$nextTick(() => {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
      const that = this;
      this.swiper = new Swiper('#report', {
        slidesPerView: 'auto',
        normalizeSlideIndex: false,
        observer: true,
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          init() {
            this.activeIndex = index;
            that.swIndex = this.activeIndex;
          },
          slideChange() {
            that.swIndex = this.activeIndex;
            that.$emit('changeId', that.followList[this.activeIndex]);
            if (
              this.activeIndex + 1 > that.avatarList.length &&
              this.activeIndex + 1 <= that.avatarList.length + that.mechanismList.length
            ) {
              that.swipeIndex = 1;
            } else if (this.activeIndex + 1 <= that.avatarList.length) {
              that.swipeIndex = 0;
            } else {
              that.swipeIndex = 2;
            }
            const float = that.$refs.float as any;
            if (that.swipeIndex === 0) {
              float.checkAvatar(
                that.followList[this.activeIndex].author,
                this.activeIndex,
                that.followList[this.activeIndex],
                that.followList[this.activeIndex].authorId,
                that.swipeIndex,
                'slide'
              );
            } else if (that.swipeIndex === 1) {
              float.checkAvatar(
                that.followList[this.activeIndex].orgName,
                this.activeIndex - that.avatarList.length,
                that.followList[this.activeIndex],
                that.followList[this.activeIndex].orgId,
                that.swipeIndex,
                'slide'
              );
            } else {
              float.checkAvatar(
                that.followList[this.activeIndex].industry,
                this.activeIndex - that.mechanismList.length - that.avatarList.length,
                that.followList[this.activeIndex],
                that.followList[this.activeIndex].industryId,
                that.swipeIndex,
                'slide'
              );
            }
          },
        },
      });
      this.makeSlide();
    });
    document.body.appendChild(this.$el);
    if (this.showRound) {
      window.addEventListener(
        'scroll',
        throttle(() => this.scrollLoading(), 300),
        true
      );
    }
  }
  mounted() {
    this.initData();
  }
}
